import React from 'react';
import {Form} from 'formik';
import classnames from 'classnames';
import FormTitle from '../FormTitle';
import ButtonCreatePDF from './ButtonCreatePDF';
import ModalPreviewDocument from '../../../../common/components/ModalPreviewDocument';
import Empty from 'common/components/Empty';
import Spinner from '../../../../common/components/Spinner';
import FieldPasteFile from '../../../../common/components/FieldPasteFile';
import AnimatedUploadingFilePopUp
  from '../../../../common/components/AnimatedUploadingFilePopUp';
import ButtonDropdownCommon from '../../../../common/components/ButtonDropdownCommon';
import FoldersAccordion from './FoldersAccordion';
import {fileFolders} from '../../../../common/constants/fileFolders';
import empty from 'common/assets/nothing.svg';
import styles from './styles.module.scss';

const Form_11View = ({
                       goToPrevPage,
                       files,
                       onFileDelete,
                       onFileSelected,
                       fileTypeIds,
                       loading,
                       calling,
                       approveButtonProps,
                       shumaTypeID,
                       setFieldValue
                     }) => {
  const getUploadFileItem = (item) => {
    return (
      <FieldPasteFile
        fieldId={'additionalFileUploaded'}
        onFileSelected={onFileSelected(fileTypeIds.additionalFile, item.id)}
        setFieldValue={setFieldValue}
        triggerType={'option'}
        customLabel={item.label}
        multiple={true}
      />
    )
  };

  return (
    <div className={styles.form_11}>
      <FormTitle title={'הפקת דוח ומסמכים'}/>
      {loading
        ? (
          <div className={styles.spinnerContainer}>
            <Spinner/>
          </div>
        )
        : (
          <Form>
            <div className={classnames(
              styles.fileFoldersContainer,
              {[styles.fileFoldersContainerEmpty]: !files || files.length === 0}
            )}>
              {
                (files && files.length > 0)
                  ? (
                    <FoldersAccordion
                      content={files}
                      onFileDelete={onFileDelete}
                      shumaTypeID={shumaTypeID}
                    />
                  )
                  : (
                    <Empty
                      icon={empty}
                      message={'ללא קבצים מצורפים'}
                    />
                  )
              }
            </div>
            <div className={styles.resultButtons}>
              <div className={styles.buttonsGroup}>
                <ButtonDropdownCommon
                  triggerComponent={
                    <div className={styles.ddButtonUpload}>
                      <span>צרף</span>
                    </div>
                  }
                  customMenuStyles={styles.ddMenu}
                  customMenuFallsStyles={styles.alignToBottom}
                  content={fileFolders.map(getUploadFileItem)}
                />
                <button
                  type="button"
                  className={styles.buttonCancel}
                  onClick={goToPrevPage}
                >
                  <span>חזור</span>
                </button>
                <ModalPreviewDocument/>
                <ButtonCreatePDF {...approveButtonProps}/>
              </div>
            </div>
          </Form>
        )}
      <AnimatedUploadingFilePopUp
        show={calling}
        duration={50}
        percentsPerSec={2}
        type={'linear'}
      />
    </div>
  );
};

export default Form_11View;
